export default __webpack_public_path__ + "static/media/IMG-20241005-WA0004.26d0eda5.jpg";